<div class="container-fluid d-flex p-0">
  <app-side-bar></app-side-bar>
  <app-contentpopup [contentPopups]="contentPopups" [content_value]="content_value" [contentKey]="contentKey"
    [contentTableArray]="contentTableArray" [content_Details]="content_Details"
    (closecontentpopup)="closecontentpopup()" [tablevalues]="tablevalues" [tablekeys]="tablekeys">
  </app-contentpopup>
  <!-- <app-popup [displaypopup]="displaypopup" [nullmessage]="nullmessage" [popupcontents]="popupcontents"
    (closepopup)="popupfunc($event)"></app-popup> -->
  <!-- Header Block -->
  <div class="container-fluid">
    <div class="container-fluid my-3">
      <div class="top-card">
        <div class="row w-100 mx-auto d-flex  ">
          <div class="col-sm-12 col-md-12 col-lg-9 pl-4">
            <!-- <img class="logo-top" src="../../assets/images/logo-M (1).png"> -->
            <span class="">Portfolio Management Suite</span>
          </div>
        </div>
      </div>
    </div>

    <p style="font-weight: bold;">Total Count :- {{total_count}}</p>

    <div class="card" style="margin: 10px;border-radius: 10px;">

      <div class="">
        <div class="row">
          <div class="col-2 col-md-2 col-sm-12" style="margin: 10px;">
            <p class="my-auto ml-3" style="font-size: 20px;font-weight: 600;">Enter The Molecule</p>
          </div>

          <div class="col-5 col-md-5 col-sm-12" style="margin: 10px;">
            <i class="fa fa-search icon" style="margin-right: 10px;"></i>
            <input class="w-75" placeholder="Enter the Molecule Name" [(ngModel)]="searchValue"
              (keydown.enter)="searchMolecule()" autofocus>
          </div>

          <div class="col-1 col-md-1 col-sm-12" style="margin: 10px;">
            <button type="button" class="btn btn-light" (click)="searchMolecule()">Submit</button>
          </div>

          <div class="col-2 col-md-2 col-sm-12" style="margin: 10px;">
            <p-dropdown [options]="submolecules" [(ngModel)]="selectedSubMolecule" autoWidth="false"
              [style]="{'width':'90%','font-size':'12px'}" optionLabel="name" placeholder="Select NDA"
              (click)="getData()" *ngIf="subMolecule">
            </p-dropdown>
          </div>

          <div class="col-1 col-md-1 col-sm-12" style="margin: 10px;">
            <button type="button" class="btn btn-light" (click)="clearFilter()">Clear</button>
          </div>

        </div>
      </div>

    </div>

    <!-- <button (click)="download()">Download</button>
    <input type="file" (change)="HandleInput($event)"/> -->

    <div class="container-fluid" *ngIf="Molecule">
      <p-toast [style]="{ marginTop: '80px' }"></p-toast>
      <div class="tab-execsum">
        <!-- PRODUCT DETAILS -->

        <div>
          <p-accordion expandIcon="pi pi-chevron-circle-down" [multiple]="true" collapseIcon="pi pi-chevron-circle-up"
            *ngIf="page_access.RetrieveInnovatorBrandProductDetails && page_access.RetrieveInnovatorBrandProductDetails === true">
            <p-accordionTab [selected]="true">
              <ng-template pTemplate="header">
                <div style="display: flex; justify-content: space-between; width: 100%;">
                  <span>{{ InnovatorHeader }}</span>
                  <span [ngStyle]="{
                    display: 'inline-block',
                    width: '24px',
                    height: '24px',
                    borderRadius: '50%',
                    backgroundColor: isProductLive ? '#28a745' : '#dc3545',
                    verticalAlign: 'middle',
                    border: '2px solid #fff',
                    boxShadow: isProductLive ? '0 0 8px #28a74555' : '0 0 8px #dc354555'
                  }" [attr.aria-label]="isProductLive ? 'Live' : 'Not Live'"
                    [attr.title]="isProductLive ? 'Live (true)' : 'Not Live (false)'">
                  </span>
                </div>
              </ng-template>
              <p *ngIf="ShowLmsMessage != ''"
                style="color: red; font-weight: bold; text-align: center; text-decoration: underline;">
                {{ ShowLmsMessage }}
              </p>
              <table class="table table-bordered" id="excel-table">
                <div class="table-responsive">
                  <thead *ngIf="!this.paramsValues.section">
                    <tr>
                      <th *ngIf="showCheckBox" style="text-align: center;">Select</th>
                      <th></th>
                      <th>
                        <i class="fa fa-edit icons" (click)="editbtn()"></i>
                        <i class="fa fa-download icons" title="Dowload file" (click)="downloadFiles()"></i>
                        <i class="fa fa-check-square icons" title="Download upon selection"
                          (click)="downloadSelected()"></i>
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr *ngFor="let Obj of DragData | Object2keyvalue; let index=index"
                      [ngStyle]="{'display': (Obj.key === 'colorindicator' || Obj.key === 'field_information') ?'none' : ' ' }">
                      <td *ngIf="showCheckBox"><input type="checkbox" style="margin-left: 2.5rem;"
                          (click)="selected_checbox(Obj.key, index)" /></td>
                      <td #headerids
                        [ngStyle]="{'display': (Obj.key === 'colorindicator' || Obj.key === 'field_information') ?'none' : ' ' }"
                        [ngClass]="[getcolorcode(Obj.key,DragData.colorindicator)]">
                        {{Obj.key}}
                        <span class="tooltip-container">
                          <i class="fas fa-info-circle info-icon"></i>
                          <div class="custom-tooltip" [innerHTML]="getTooltipContent(Obj.key)"></div>
                        </span>
                        <div class="action-buttons">
                          <button pButton
                            [label]="fieldInformation?.[Obj.key]?.[0]?.field_verified === true ? 'Verified' : 'Verify'"
                            class="custom-button verify-btn" (click)="verifyField(Obj.key)"
                            [disabled]="fieldInformation?.[Obj.key]?.[0]?.field_verified === true"
                            [ngStyle]="{ 'cursor': fieldInformation?.[Obj.key]?.[0]?.field_verified === true ? 'not-allowed' : 'pointer' }">
                          </button>

                          <button pButton
                            [label]="fieldInformation?.[Obj.key]?.[0]?.field_reviewed === true ? 'Under Review' : 'Review'"
                            class="custom-button review-btn" (click)="openReviewDialog(Obj.key)"
                            [disabled]="fieldInformation?.[Obj.key]?.[0]?.field_reviewed === true"
                            [ngStyle]="{ 'cursor': fieldInformation?.[Obj.key]?.[0]?.field_reviewed === true ? 'not-allowed' : 'pointer' }">
                          </button>
                        </div>
                      </td>
                      <td>
                        <!-- <div class="table-responsive">
                          <table class="table table-bordered" id="verticalTable">
                            <tbody>
                              <tr *ngFor="let key of responseKeys; let rowIndex = index">
                                <td>
                                  <input type="text" [(ngModel)]="responseKeys[rowIndex]"
                                    (change)="updateHeader(rowIndex)" />
                                </td>
                                <td *ngFor="let colIndex of columnIndexes">
                                  <input type="text" [(ngModel)]="responseData[responseKeys[rowIndex]][colIndex]" />
                                </td>
                                <td>
                                  <button (click)="deleteNewRow(rowIndex)">Delete Row</button>
                                </td>
                              </tr>
                              <tr>
                                <td></td>
                                <td *ngFor="let colIndex of columnIndexes">
                                  <button (click)="deleteColumn(colIndex)">Delete Column</button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        <button (click)="addColumn()">Add Column</button>
                        <button (click)="addRow()">Add Row</button> -->
                        <div *ngIf="Obj.key === 'FDA label' && (isObject(Obj.value) || isArray(Obj.value))">
                          <table class="table table-bordered" id="innertable">
                            <thead style="font-size: 12px;">
                              <tr>
                                <ng-container
                                  *ngFor="let key of isobjectKeys(isArray(Obj.value) ? (Obj.value[0] || {}) : Obj.value)">
                                  <th *ngIf="key === 'path' || key === 'action date'">
                                    {{ key }}
                                  </th>
                                </ng-container>
                              </tr>
                            </thead>
                            <tbody style="font-size: 10px;">
                              <tr *ngFor="let row of (isArray(Obj.value) ? Obj.value : [Obj.value]); let m=index">
                                <ng-container *ngFor="let key of isobjectKeys(row)">
                                  <td *ngIf="key === 'path' || key === 'action date'">
                                    <!-- VIEW MODE -->
                                    <ng-container *ngIf="!showedit">
                                      <ng-container *ngIf="key === 'path'">
                                        <ng-container *ngIf="row[key] !== 'N/A'; else showNA">
                                          <i class="fa fa-file-pdf-o" style="font-size: 30px; cursor: pointer;"
                                            (click)="openPdf(row[key])"></i>
                                        </ng-container>
                                        <ng-template #showNA>
                                          N/A
                                        </ng-template>
                                      </ng-container>
                                       <ng-container *ngIf="key !== 'path'">
                                         <ng-container *ngIf="key === 'action date'">
                                           {{ formatDate(row[key]) }}
                                         </ng-container>
                                         <ng-container *ngIf="key !== 'action date'">
                                           {{ row[key] || 'N/A' }}
                                         </ng-container>
                                       </ng-container>
                                    </ng-container>

                                    <!-- EDIT MODE -->
                                    <ng-container *ngIf="showedit">
                                      <ng-container *ngIf="key === 'path'">
                                        <div style="display: flex; flex-direction: column; gap: 5px;">
                                          <div style="display: flex; align-items: center; gap: 10px;">
                                            <input type="file" #fileInput style="display: none"
                                              (change)="onFileSelected($event, {value: row}, key)">
                                            <button type="button" class="btn btn-sm btn-outline-primary"
                                              (click)="fileInput.click()" title="Upload New File">
                                              <i class="fa fa-upload"></i> Upload
                                            </button>
                                            <button type="button" class="btn btn-sm"
                                              [ngClass]="row[key] === 'N/A' ? 'btn-secondary' : 'btn-outline-secondary'"
                                              (click)="setNA({value: row}, key)" title="Toggle N/A">
                                              N/A
                                            </button>
                                          </div>
                                          <div style="font-size: 11px; margin-top: 2px;">
                                            <span *ngIf="row[key] !== 'N/A'"><b>File:</b> {{
                                              selectedFilenames.get(row) || row[key] }}</span>
                                            <span *ngIf="row[key] === 'N/A'" style="color: red;"><b>Status:</b>
                                              N/A</span>
                                          </div>
                                        </div>
                                      </ng-container>
                                      <ng-container *ngIf="key === 'action date'">
                                        <p-calendar [(ngModel)]="row[key]" dateFormat="dd/mm/yy" appendTo="body"
                                          (onSelect)="onDateSelect($event, {value: row}, key)"></p-calendar>
                                      </ng-container>
                                    </ng-container>
                                  </td>
                                </ng-container>
                                <td *ngIf="isArray(Obj.value) && showedit"
                                  style="text-align: center; vertical-align: middle; width: 40px;">
                                  <i class="fas fa-trash" style="font-size: 18px; cursor: pointer; color: #dc3545;"
                                    (click)="deleteRow(Obj.value, m)" title="Delete Row"></i>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        <!-- <div *ngIf="Obj.key === 'FDA label'">
                          <table class="table table-bordered" id="innertable">
                            <thead style="font-size: 12px;">
                              <tr>
                                <th *ngFor="let key of objectKeys(Obj.value)">
                                  {{ key }}
                                </th>
                              </tr>
                            </thead>
                            <tbody style="font-size: 10px;">
                              <tr>
                                <td *ngFor="let key of objectKeys(Obj.value)">
                                  <ng-container *ngIf="key === 'path'">
                                    <i *ngIf="Obj.value[key] !== 'N/A'"
                                      [ngClass]="[Obj.key === 'FDA label' && Obj.value[key] !== 'N/A' ? 'editcls' : 'editdisable']"
                                      (click)="openPdf(Obj.value[key])" class="fa fa-file-pdf-o"
                                      style="font-size: 30px;"></i>
                                  </ng-container>
                                  <ng-container *ngIf="key !== 'path'">
                                    {{ Obj.value[key] }}
                                  </ng-container>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div> -->
                        <div *ngIf="(Obj.value | arrayChk) && Obj.key !== 'FDA label';else displayvalue;let is=index">
                          <div *ngIf="Obj.value | tableChk;else list">
                            <div class="table-responsive">
                              <table class="table table-bordered" id="innertable">
                                <thead style="font-size: 12px;">
                                  <tr>
                                    <th *ngFor="let headers of Obj.value | tableHeaders" id="innertableheader">
                                      <p>{{headers}}</p>
                                      <!-- <p [ngClass]="[showedit?'editcls':'editdisable']" ><input type="text" (change)="editdata($event,Obj.value,Obj.key)" class="p1" value={{headers}}/></p> -->
                                    </th>
                                  </tr>
                                </thead>
                                <tbody style="font-size: 10px;">
                                  <tr *ngFor="let trows of Obj.value | tableBody;let m=index">
                                    <td *ngFor="let rdata of trows;let iindex =index">
                                      <p [ngClass]="[showedit?'editcls':'editdisable']">
                                        <input type="text" #elementRef
                                          (change)="editdata($event,Obj.value,Obj.key,trows,rdata,Obj,m,Obj.key,'rdata',iindex)"
                                          [ngClass]="[rdata.length>=20?'input-size':'']" value={{rdata}} id={{rdata}} />
                                      </p>
                                      <p [ngClass]="[!showedit && Obj.key !=='FDA label'?'editcls':'editdisable']">
                                        {{rdata}}
                                      </p>
                                    </td>
                                    <i *ngIf="Obj.value.length > 1 && showedit" [ngClass]="['editcls']"
                                      style="font-size: 20px; cursor: pointer; margin: 10px;"
                                      class="fas fa-trash float-left" (click)="deleteRow(Obj.value, m)">
                                    </i>
                                    <!-- <i [ngClass]="[showedit ? 'editcls' : 'editdisable']"
                                      style="font-size: 20px; cursor: pointer; margin: 10px;"
                                      class="fas fa-trash float-left" (click)="deleteRow(Obj.value,m)"></i> -->
                                  </tr>

                                  <i [ngClass]="[showedit?'editcls':'editdisable']"
                                    style="font-size: 20px;margin-top: 10px;" class="fas fa-plus float-left"
                                    (click)="addItems(Obj.value,Obj.key,trows,rdata,Obj,m,Obj.key)"></i>
                                  <button [ngClass]="[showedit?'editcls':'editdisable']" style="font-size: 15px;
                                  margin-left: 35px;
                                  margin-top: 10px;" (click)="deleteTable(Obj.key)">
                                    Delete Table
                                  </button>
                                  <!-- <i [ngClass]="[showedit?'editcls':'editdisable']" style="font-size: 20px;"
                                    class="fas fa-minus float-left" (click)="toggleInputVisibility()"></i> -->
                                  <!-- <button [ngClass]="[!showedit && Obj.key !=='FDA label'?'editcls':'editdisable']"
                                    *ngIf="Obj.value.length>sliceEnd" class="btn btn-success"
                                    (click)="showLess(Obj.value,Obj.key,trows,rdata,Obj,m,Obj.key)">Show More</button> -->

                                </tbody>
                              </table>
                            </div>
                          </div>
                          <ng-template #list>
                            <ul>

                              <li *ngFor="let lItems of Obj.value;let inds=index">
                                <p [ngClass]="[showedit?'editcls':'editdisable']">
                                  <!-- <input type="text" [ngClass]="[lItems.length>=20?'input-size':'']" (change)="editdata($event,Obj.value,Obj.key,lItems,inds,'lItems')" value={{lItems}} /> -->
                                  <textarea [ngClass]="[lItems.length>=20?'input-size':'']"
                                    (change)="editdata($event,Obj.value,Obj.key,lItems,inds,'lItems')"
                                    style="height: 30px;" value={{lItems}} cols="30" rows="10">
                                  </textarea>
                                  <!-- <i class="fas fa-trash" style="font-size: 20px; cursor: pointer; margin-left: 10px;"
                                    (click)="deleteListItem(Obj.value, inds, Obj.key)"></i> -->
                                  <i *ngIf="Obj.value.length > 1 && inds > 0" class="fas fa-trash"
                                    style="font-size: 20px; cursor: pointer; margin-left: 10px;"
                                    (click)="deleteListItem(Obj.value, Obj.key, inds)"></i>
                                </p>
                                <p [ngClass]="[!showedit?'editcls':'editdisable']">

                                  {{lItems}}

                                </p>

                              </li>
                              <i [ngClass]="[showedit?'editcls':'editdisable']" style="font-size: 20px;"
                                class="fas fa-plus float-left"
                                (click)="addListItem(Obj.value,lItems,Obj,m,Obj.key)"></i>

                              <button [ngClass]="[showedit?'editcls':'editdisable']" style="margin-left: 35px;"
                                (click)="addTable(Obj.value,lItems,Obj,m,Obj.key)">Add Table</button>
                              <!-- <button [ngClass]="[!showedit && Obj.key !=='FDA label'?'editcls':'editdisable']"
                                *ngIf="Obj.key !== 'Dosage and Administration' && Obj.key !== 'Recommended dose' &&  Obj.key !== 'Indications and Usage' && Obj.value.length>5"
                                class="btn btn-success"
                                (click)="showArray(Obj.value,Obj.key,trows,rdata,Obj,m,Obj.key)">Show
                                More</button> -->

                            </ul>
                          </ng-template>
                        </div>
                        <ng-template #displayvalue>
                          <ng-container
                            *ngIf="['Dosage and Administration', 'Indications and Usage', 'Recommended dose'].includes(Obj.key)">
                            <div [ngClass]="[showedit ? 'editcls' : 'editdisable']">
                              <ckeditor [editor]="Editor" [ngModel]="Obj.value"
                                (ngModelChange)="editdata($event, Obj.value, Obj.key, index, '')"></ckeditor>
                            </div>
                            <div class="editor-content" style="margin-bottom: 10px;">
                              <p [ngClass]="[showedit ? 'editdisable' : 'editcls']"
                                [innerHTML]="sanitizeHtml(Obj.value)">
                              </p>
                            </div>
                          </ng-container>

                          <ng-container
                            *ngIf="!['Dosage and Administration', 'Indications and Usage', 'Recommended dose'].includes(Obj.key)">
                            <p
                              [ngClass]="[showedit && Obj.key !== 'FDA label' && Obj.key !== 'FDA product specific BE guidance' && Obj.key !== 'Brand Name/Proprietary Name' ? 'editcls' : 'editdisable']">
                              <input type="text" [ngClass]="[Obj.value?.length>=20?'input-size':'']" value={{Obj.value}}
                                [readonly]="Obj.key === 'Brand Name/Proprietary Name'"
                                (change)="editdata($event,Obj.value,Obj.key,index,'')" />
                            </p>
                            <p
                              [ngClass]="[!showedit && Obj.key !== 'FDA label' && Obj.key !== 'FDA product specific BE guidance' ? 'editcls' : 'editdisable']">
                              {{ Obj.value }}
                            </p>
                          </ng-container>

                          <!-- FDA label: text input when value is a plain string (N/A or file path) -->
                          <ng-container *ngIf="Obj.key === 'FDA label' && !isArray(Obj.value) && !isObject(Obj.value)">
                            <p [ngClass]="[showedit ? 'editcls' : 'editdisable']">
                              <input type="text" [ngClass]="[Obj.value?.length >= 20 ? 'input-size' : '']"
                                value="{{Obj.value}}" (change)="editdata($event, Obj.value, Obj.key, index, '')" />
                            </p>
                          </ng-container>

                          <!-- + and Add Table buttons for non-special fields -->
                          <i *ngIf="!['Dosage and Administration', 'Indications and Usage', 'Recommended dose', 'Brand Name/Proprietary Name', 'FDA label', 'FDA product specific BE guidance'].includes(Obj.key)"
                            [ngClass]="[showedit ? 'editcls' : 'editdisable']" style="font-size: 20px;"
                            class="fas fa-plus float-left"
                            (click)="addListItem(Obj.value, Obj.key, Obj, Obj, Obj.key)"></i>

                          <button
                            *ngIf="!['Dosage and Administration', 'Indications and Usage', 'Recommended dose', 'Brand Name/Proprietary Name', 'FDA label', 'FDA product specific BE guidance'].includes(Obj.key)"
                            [ngClass]="[showedit ? 'editcls' : 'editdisable']" style="margin-left: 35px;"
                            (click)="addTable(Obj.value, lItems, Obj, m, Obj.key)">Add Table</button>

                          <!-- FDA label: + button
                               In string state → creates the table with first empty row (same as Add Table)
                               In array state  → adds another empty row -->
                          <!-- <i *ngIf="Obj.key === 'FDA label' && showedit"
                            [ngClass]="[showedit ? 'editcls' : 'editdisable']"
                            style="font-size: 20px; cursor: pointer;" class="fas fa-plus float-left"
                            (click)="isArray(Obj.value) ? addItems(Obj.value, Obj.key, '', '', Obj, '', Obj.key) : addTable(Obj.value, null, Obj, 0, Obj.key)"></i> -->

                          <button *ngIf="Obj.key === 'FDA label'" [ngClass]="[showedit ? 'editcls' : 'editdisable']"
                            style="margin-left: 35px;"
                            (click)="isArray(Obj.value) ? deleteTable(Obj.key) : addTable(Obj.value, null, Obj, 0, Obj.key)">
                            {{ isArray(Obj.value) ? 'Delete Table' : 'Add Table' }}
                          </button>

                          <!-- FDA label view mode: PDF icon or N/A -->
                          <i *ngIf="Obj.key === 'FDA label' && Obj.value !== 'N/A' && !isObject(Obj.value) && !isArray(Obj.value) && !showedit"
                            (click)="openPdf(Obj.value)" class="fa fa-file-pdf-o" style="font-size: 30px;"></i>

                          <div *ngIf="Obj.key === 'FDA label' && Obj.value === 'N/A' && !isObject(Obj.value) && !isArray(Obj.value) && !showedit">N/A</div>
                        </ng-template>

                        <!-- <ng-template #displayvalue>
                          <p
                            [ngClass]="[showedit && Obj.key !=='FDA label' && Obj.key !== 'FDA product specific BE guidance'?'editcls':'editdisable']">
                            <input type="text" [ngClass]="[Obj.value?.length>=20?'input-size':'']" value={{Obj.value}}
                              (change)="editdata($event,Obj.value,Obj.key,index,'')" />
                          </p>
                          <p
                            [ngClass]="[!showedit && Obj.key !=='FDA label' && Obj.key !== 'FDA product specific BE guidance'?'editcls':'editdisable']">
                            {{Obj.value}}

                          </p>
                          <i [ngClass]="[showedit?'editcls':'editdisable']" style="font-size: 20px;"
                            class="fas fa-plus float-left"
                            (click)="addListItem(Obj.value, Obj.key, Obj, Obj, Obj.key)"></i>

                          <button [ngClass]="[showedit?'editcls':'editdisable']" style="margin-left: 35px;"
                            (click)="addTable(Obj.value,lItems,Obj,m,Obj.key)">Add Table</button>
                          <i [ngClass]="[ Obj.key ==='FDA label' && Obj.value !== 'N/A'?'editcls':'editdisable']"
                            (click)="openPdf(Obj.value)" class="fa fa-file-pdf-o" style="font-size: 30px;"></i>
                          <i [ngClass]="[ Obj.key ==='FDA product specific BE guidance' && Obj.value !== 'N/A'?'editcls':'editdisable']"
                            (click)="openPdf(Obj.value)" class="fa fa-file-pdf-o" style="font-size: 30px;"></i>
                          <div *ngIf="Obj.key ==='FDA label' && Obj.value === 'N/A'">N/A</div>
                          <div *ngIf="Obj.key ==='FDA product specific BE guidance' && Obj.value === 'N/A'">N/A</div>
                        </ng-template> -->

                        <div *ngFor="let edited of isChanged(Obj.key)">
                          <div *ngIf="edited === Obj.key" [id]="Obj.key" style="display: flex;">
                            <div *ngIf="acceptLoader" class="loader" style="margin-left: 1rem">
                              <div class="loader-inner"></div>
                            </div>
                            <div *ngIf="rejectLoader" class="loader" style="margin-left: 1rem">
                              <div class="loader-inner"></div>
                            </div>
                            <div *ngIf="!acceptLoader && !rejectLoader">
                              <i class="fa fa-check" title="Accept" (click)="handelAction(Obj,'accept')"
                                style="cursor: pointer;color:#2bc44e;padding-left:1rem;"></i>
                              <i class="fa fa-remove" title="Reject" (click)="handelAction(Obj,'reject')"
                                style="cursor: pointer;padding-left:3rem;color:red"></i>
                            </div>

                          </div>
                        </div>

                      </td>

                    </tr>
                    <tr>
                      <td *ngIf="showCheckBox">
                        <button class="btn btn-primary" (click)="downloadSelectedData()">Download</button>
                      </td>
                    </tr>
                  </tbody>
                </div>
              </table>
              <p-dialog header="Review Entry" [(visible)]="displayReviewDialog" [modal]="true" [closable]="false"
                class="custom-dialog">
                <div class="dialog-content">
                  <div class="p-field">
                    <label for="email">Select Email:</label>
                    <p-dropdown [options]="emailList" [(ngModel)]="selectedEmail" placeholder="Select Email">
                    </p-dropdown>
                    <div *ngIf="submitted && !selectedEmail" class="error-text">
                      Email is required.
                    </div>
                  </div>

                  <div class="p-field">
                    <label for="key">Key Name:</label>
                    <input id="key" type="text" pInputText [(ngModel)]="selectedKey" readonly class="readonly-input">
                  </div>

                  <div class="p-field">
                    <label for="comment">Comment:</label>
                    <textarea id="comment" pInputTextarea [(ngModel)]="reviewComment" rows="2" cols="40"
                      class="comment-box"></textarea>
                    <small class="comment-warning">
                      {{ reviewComment.length < 15 ? 'Minimum 15 characters required.' : '&nbsp;' }} </small>
                  </div>
                </div>

                <p-footer>
                  <button type="button" pButton icon="pi pi-times" label="Cancel" class="cancel-btn"
                    (click)="displayReviewDialog = false"></button>
                  <button type="button" pButton icon="pi pi-check" label="Submit" class="submit-btn"
                    [disabled]="!isCommentValid()" (click)="submitReview()"></button>
                </p-footer>
              </p-dialog>
              <div *ngIf="showedit" class="text-center">
                <button class="btn btn-primary" (click)="saveEdit()">Save</button>
              </div>
            </p-accordionTab>

            <!-- SECOND SECTION -- PATENT INFORMATION -->
            <p-accordionTab [header]="patentHeader"
              *ngIf="page_access.PatentInformation && page_access.PatentInformation === true">
              <p-toast [style]="{ marginTop: '80px' }"></p-toast>
              <app-patent-info [ActiveIngred]="activeIngredientforPI" [BrandName]="brandNameforPI"
                [saveOldData]="saveOldData" [NDAnumber]="ndaforPI"
                (patentHeaderUpdated)="onPatentHeaderUpdate($event)"></app-patent-info>
            </p-accordionTab>

            <p-accordionTab [header]="litigationHeader"
              *ngIf="page_access.LitigationInformation && page_access.LitigationInformation === true">
              <p-toast [style]="{ marginTop: '80px' }"></p-toast>
              <app-litigation-information [BrandName]="brandNameforPI" [NDAnumber]="ndaforPI"
                [saveOldData]="saveOldData" (litigationHeaderUpdated)="onLitigationUpdate($event)">
              </app-litigation-information>
            </p-accordionTab>

            <!-- THIRD SECTION --REGULATORY INFORMATION -->
            <p-accordionTab [header]="regulatoryHeader"
              *ngIf="page_access.RegulatoryInformation && page_access.RegulatoryInformation === true">
              <p-toast [style]="{ marginTop: '80px' }"></p-toast>
              <app-regulatory-info [ActiveIngred]="activeIngredientforPI" [BrandName]="brandNameforPI"
                [NDAnumber]="ndaforPI" [saveOldData]="saveOldData"
                (regulatoryHeaderUpdated)="onRegulatoryUpdate($event)"></app-regulatory-info>
            </p-accordionTab>

            <!-- FOURTH SECTION -- -->
            <p-accordionTab [header]="clinicalHeader"
              *ngIf="page_access.ClinicalInformation && page_access.ClinicalInformation === true">
              <p-toast [style]="{ marginTop: '80px' }"></p-toast>
              <app-clinical-info [ActiveIngred]="activeIngredientforPI" [BrandName]="brandNameforPI"
                [NDAnumber]="ndaforPI" [saveOldData]="saveOldData"
                (clinicalInfoHeaderUpdated)="onClinicalUpdate($event)"></app-clinical-info>
            </p-accordionTab>

            <!-- FIFTH SECTION -->
            <p-accordionTab [header]="APIInformationHeader"
              *ngIf="page_access.APIInformation && page_access.APIInformation === true">
              <p-toast [style]="{ marginTop: '80px' }"></p-toast>
              <app-api-info [ActiveIngred]="activeIngredientforPI" [BrandName]="brandNameforPI" [NDAnumber]="ndaforPI"
                [saveOldData]="saveOldData" (ApiInfoHeaderUpdated)="onApiInformationUpdate($event)"></app-api-info>
            </p-accordionTab>

            <!-- SIXTH SECTION -->
            <p-accordionTab [header]="formulationHeader"
              *ngIf="page_access.FormulationInformation && page_access.FormulationInformation === true">
              <p-toast [style]="{ marginTop: '80px' }"></p-toast>
              <app-formulation-info [ActiveIngred]="activeIngredientforPI" [BrandName]="brandNameforPI"
                [NDAnumber]="ndaforPI" [saveOldData]="saveOldData"
                (formulationHeaderUpdated)="onFormulationUpdate($event)"></app-formulation-info>
            </p-accordionTab>

            <!-- SEVENTH SECTION -->
            <p-accordionTab [header]="competitiveHeader"
              *ngIf="page_access.CompetitiveIntelligence && page_access.CompetitiveIntelligence === true">
              <p-toast [style]="{ marginTop: '80px' }"></p-toast>
              <app-competitive-intelligence [ActiveIngred]="activeIngredientforPI" [BrandName]="brandNameforPI"
                [NDAnumber]="ndaforPI" [saveOldData]="saveOldData"
                (CompetitiveHeaderUpdated)="onCompetitiveUpdate($event)"></app-competitive-intelligence>
            </p-accordionTab>

            <!-- EIGHT SECTION -->
            <p-accordionTab [header]="executiveHeader"
              *ngIf="page_access.ExecutiveSummary && page_access.ExecutiveSummary === true">
              <p-toast [style]="{ marginTop: '80px' }"></p-toast>
              <app-executive-summary [ActiveIngred]="activeIngredientforPI" [BrandName]="brandNameforPI"
                [NDAnumber]="ndaforPI" [saveOldData]="saveOldData"
                (executiveHeaderUpdated)="onExecutiveUpdate($event)"></app-executive-summary>
            </p-accordionTab>

            <!-- NINTHSECTION -->
            <p-accordionTab [header]="costingRelatedHeader"
              *ngIf="page_access.CostingRelatedOthers && page_access.CostingRelatedOthers === true">
              <p-toast [style]="{ marginTop: '80px' }"></p-toast>
              <app-costing-info [ActiveIngred]="activeIngredientforPI" [BrandName]="brandNameforPI"
                [NDAnumber]="ndaforPI" [saveOldData]="saveOldData"
                (costingHeaderUpdated)="onCostingRelatedUpdate($event)"></app-costing-info>
            </p-accordionTab>
          </p-accordion>

        </div>
      </div>
    </div>
    <div class="nodata" *ngIf="noData">
      <p> No Data Found</p>
    </div>
  </div>
</div>